import styled from 'styled-components'
import { color, typography } from '@primer-io/goat'

import Clickable from 'components/Clickable'
import { elevationSmall, elevationLarge } from 'ds/elevation'

export const boxPadding = 24

const Box = styled.div.attrs(p => ({ borderOnly: true }))`
	position: relative;
	overflow: hidden;
	padding: ${p => p.padding || boxPadding}px;
	background: ${p => p.bgColor || 'white'};
	border-radius: 4px;
	border: 1px solid ${color('gray-200')};
	${p =>
		!p.borderOnly &&
		`
    /* ek: can't use color('...') functions inside p => functions, because
     * they clash with goat theme. */
    border: none;
    ${elevationSmall}
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.2), 0px 0px 1px rgba(0, 0, 0, 0.3);
  `}

	display: flex;
	flex-direction: column;
	gap: ${p => p.gap || 16}px;
	justify-content: ${p => p.justify || 'flex-end'};
	@supports (-webkit-touch-callout: none) and (not (translate: none)) {
		> :not(:last-child) {
			margin-bottom: ${p => p.gap || 16}px;
		}
	}
	p,
	dd {
		${typography('body-medium')}
		color: ${color('gray-600')};
		${p => p.theme.above('medium')`
      max-width: 300px;
    `}
		${p => p.theme.above('large')`
      max-width: 356px;
    `}
    ${p => p.theme.above('extraLarge')`
      max-width: 415px;
    `}
	}
	transform: translateY(0);
	${p =>
		p.as === Clickable &&
		`
    transition: transform .3s ease, box-shadow .3s ease;
    &:hover,
    &:focus {
      ${elevationLarge}
      transform: translateY(-4px);
    }
  `}
`

export default Box
